import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import DashboardLayout from '@component/layout/dashboard-layout';
import { LOGIN_PATH, pathToModule } from '@constant/routes';
import { useAuth } from '@context/auth-context';
import { useToast } from '@context/toast-context';
import { isPdmDashboardRole, renderPdmDashboard } from '@lib/pdm/loadPdmEngine';
import { useAppStore } from '@store/app-store';

export default function AppLayout() {
  const { user, logout } = useAuth();
  const { showToast } = useToast();
  const location = useLocation();
  const navigate = useNavigate();
  const setActiveModule = useAppStore((s) => s.setActiveModule);
  const setSelectedKpiCard = useAppStore((s) => s.setSelectedKpiCard);
  const activeModule = pathToModule(location.pathname) ?? user?.defaultModule ?? 'dashboard';

  useEffect(() => {
    if (activeModule) setActiveModule(activeModule);
  }, [activeModule, setActiveModule]);

  useEffect(() => {
    if (activeModule !== 'dashboard') return;
    if (isPdmDashboardRole(user)) {
      setTimeout(() => renderPdmDashboard(), 0);
    } else {
      setSelectedKpiCard('civil');
    }
  }, [activeModule, user, setSelectedKpiCard]);

  const handleLogout = () => {
    logout();
    navigate(LOGIN_PATH, { replace: true });
    showToast('', 'Signed out successfully');
  };

  return (
    <DashboardLayout onLogout={handleLogout}>
      <Outlet />
    </DashboardLayout>
  );
}
